import React from 'react';

import {
  AlIttihad,
  AlHilal,
  AlNassr,
  AlAhli,
  AlShabab,
  AlEttifaq,
  AlFateh,

} from "../clubs";

const Spl = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won Saudi Pro League (SPL).</h1>
      <AlIttihad />
      <AlHilal />
      <AlNassr />
      <AlAhli />
      <AlFateh />
      <AlShabab />
      <AlEttifaq />
    </div>
  )
}

export default Spl